import { type IconToken } from '@1debit/icons';
import { forwardRef } from 'react';

import { type AsChildProps } from '../../client/ClickableAnalyticsSlot';
import {
	BaseIconButton,
	type BaseIconButtonDefaultProps,
	type BaseIconButtonElementProps,
} from '../BaseIconButton/BaseIconButton';

const ICON_SIZE = 10;

export type CircledIconButtonVariant = 'default' | 'inverse' | 'alwaysDark';

type CircledIconButtonOwnProps = {
	icon: Extract<IconToken, `micro_${string}`>;
	variant?: CircledIconButtonVariant;
};

export type CircledIconButtonProps = AsChildProps<BaseIconButtonElementProps> &
	CircledIconButtonOwnProps &
	Omit<BaseIconButtonDefaultProps, 'icon'>;

export const CircledIconButton = forwardRef<HTMLButtonElement, CircledIconButtonProps>(
	({ variant = 'default', ...rest }, ref) => {
		return <BaseIconButton ref={ref} iconSize={ICON_SIZE} variant={variant} {...rest} padding="p-[5px]" />;
	},
);
